/**
 * @const mediaPortrait
 * Media query for portrait viewports
 */
export const mediaPortrait = {
    query: '(orientation: portrait)',
};

/**
 * @const mediaPortraitMobile
 * Media query for portrait viewports under 600px wide
 */
export const mediaPortraitMobile = {
    query: '(orientation: portrait) and (max-width: 599px)',
};

/**
 * @const mediaPortraitTablet
 * Media query for portrait viewports larger than 600px wide
 */
export const mediaPortraitTablet = {
    query: '(orientation: portrait) and (min-width: 600px)',
};

/**
 * @const mediaLandscape
 * Media query for landscape viewports
 */
export const mediaLandscape = {
    query: '(orientation: landscape)',
};

/**
 * @const mediaLandscapeMobile
 * Media query for landscape viewports under 600px high
 */
export const mediaLandscapeMobile = {
    query: '(orientation: landscape) and (max-height: 599px)',
};

/**
 * @const mediaLandscapeTablet
 * Media query for landscape viewports over 600px high
 */
export const mediaLandscapeTablet = {
    query: '(orientation: landscape) and (min-height: 600px)',
};

/**
 * @const mediaLandscapeWide
 * Media query for landscape viewports over 600px high and widescreen
 */
export const mediaLandscapeWide = {
    query: '(orientation: landscape) and (min-aspect-ratio: 8/5) and (min-height: 600px)',
};
